import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AppProvider } from "./state/AppContext";
import { AuthGate } from "./state/AuthContext";
import { DemoWarmupNotice } from "./components/DemoWarmupNotice";
import "./styles/app.css";

const style = document.createElement("style");
style.textContent = "@keyframes pads-spin { to { transform: rotate(360deg); } }";
document.head.appendChild(style);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <DemoWarmupNotice />
    <AuthGate><AppProvider>
      <App />
    </AppProvider></AuthGate>
  </StrictMode>,
);
